export default __webpack_public_path__ + "static/screenshot-feature-importances-f49ba35c786818c3420bf0a79191507d.png";